module.exports = __webpack_public_path__ + "img/summary.088527ee.png";